import { createUseStyles } from 'react-jss';
import { ICaremapNote } from '../model/NotesClient';
import { IRecording } from '../../appointments/recording/RecordingState';
import { highlightMatch } from '../utils/highlightMatch';

const useStyles = createUseStyles({
    content: {
        color: 'unset !important',
        display: '-webkit-box',
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': 2,
        // for non-webkit browsers (Firefox)
        maxHeight: '3.8rem',
        // .sc-ion-label-md-s p sets a smaller font-size than we want
        fontSize: 'inherit !important'
    }
});

const htmlToText = (html: string): string => {
    return new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
};

export const CareMapNotesListContent: React.FC<{ note: ICaremapNote; searchText?: string }> = ({ note, searchText = '' }) => {
    const classes = useStyles();

    const recording = note.otherAttributes.recording as IRecording | undefined;
    const content = recording?.summary?.shortSummary || note.html;

    if (searchText) {
        const plainText = recording?.summary?.shortSummary || htmlToText(note.html);
        return (
            <p className={classes.content} data-type="content">
                {highlightMatch(plainText, searchText)}
            </p>
        );
    }

    return (
        <p className={classes.content}
            data-type="content"
            dangerouslySetInnerHTML={{ __html: content.split('\n').join('<br/>')}}
        />
    );
};
